import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionBox = styled(Box)(() => ({
  margin: '40px 0',
}));

export const FlexSpaceBetweenBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const InputTitle = styled(Typography)(() => ({
  paddingBottom: '4px',
  fontSize: '14px',
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  borderBottom: '1px solid #8B8C8E',
  inlineSize: 'fit-content',
  minWidth: '180px',
  paddingLeft: '8px',
  minHeight: '28px',
}));

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'end',
  gap: 20,
  margin: '80px 0',
}));

export const DownloadButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  borderRadius: '10px',
  width: ' 250px',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  fontWeight: 600,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));
